// frontend/src/components/matching/MissingTable.jsx
import MatchedFieldsBadges from "./MatchedFieldsBadges";
import PageLink from "./PageLink";
import SourceLink from "./SourceLink";
import {
  BASE_SPEC_FIELDS, SpecsCell, ScoreBadge, EditedBadge, ReqQtyCell, EditProductCell, EditToggleCell,
} from "./cells";
import "./Matching.css";

// Missing positions also show the stone type, which explains most non-matches.
const MISSING_SPEC_FIELDS = [...BASE_SPEC_FIELDS, ["Steinart", "Steinart"]];
// Best candidate + Best score are replaced by the product search while editing.
const EDIT_COLSPAN = 2;

export default function MissingTable({ results, corrections = {}, editingRow = null, onEditRow, onCorrect, documentUrl = "", documentName = "", catalogProducts = [] }) {
  if (!results.length) {
    return <p className="ds-empty">All LV positions have a matching product.</p>;
  }
  return (
    <div className="mt-section">
      <SourceLink url={documentUrl} name={documentName} />
      <div className="ds-table-wrap">
        <table className="ds-table">
          <thead>
            <tr>
              <th>Position</th>
              <th>LV title</th>
              <th>Specs</th>
              <th>Best candidate</th>
              <th>Best score</th>
              <th>Req. qty</th>
              <th>Page</th>
              {onEditRow && <th><span className="ds-visually-hidden">Edit</span></th>}
            </tr>
          </thead>
          <tbody>
            {results.map((r, i) => {
              const lv = r.lv_item;
              const pos = lv.position || String(i);
              const correctedProd = corrections[pos];
              const bm = r.best_match;
              const isEditing = editingRow === pos;
              return (
                <tr key={i} className={`mt-row-missing${correctedProd ? " mt-row-corrected" : ""}`}>
                  <td className="mt-pos">{lv.position || "—"}</td>
                  <td className="mt-title">{lv.title || "—"}</td>
                  <SpecsCell specs={lv.specs} fields={MISSING_SPEC_FIELDS} />
                  {isEditing ? (
                    <EditProductCell
                      colSpan={EDIT_COLSPAN}
                      catalogProducts={catalogProducts}
                      onSelect={(product) => { if (onCorrect) onCorrect(pos, product); }}
                      onCancel={() => onEditRow(null)}
                    />
                  ) : (
                    <>
                      <td className="mt-product">
                        {correctedProd ? (
                          <>{correctedProd.artikelnummer} – {correctedProd.name} <EditedBadge /></>
                        ) : bm ? (
                          <>{bm.product.artikelnummer} – {bm.product.name || "—"}<MatchedFieldsBadges matchedFields={bm.matched_fields} /></>
                        ) : "No candidate found"}
                      </td>
                      <td className="mt-nowrap">
                        <ScoreBadge score={bm ? bm.score : 0} />
                      </td>
                    </>
                  )}
                  <ReqQtyCell result={r} />
                  <td className="mt-page">
                    {lv.page_number != null
                      ? <PageLink url={documentUrl} page={lv.page_number} />
                      : "—"}
                  </td>
                  {onEditRow && (
                    <EditToggleCell isEditing={isEditing} title="Select product" onEdit={() => onEditRow(pos)} />
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
